// accordion（SPのみ）========================================================
(function setupAccBoxMenu() {
    const menus = document.querySelectorAll('.js-accBoxMenu');
    if (!menus.length) return;

    const mqSp = window.matchMedia('(max-width: 749px)');

    menus.forEach((menu) => {
        const secs = menu.querySelectorAll('.js-accSec');
        if (!secs.length) return;

        const spOnly = menu.dataset.accSpOnly === 'true';

        const applyMode = () => {
            const isSp = mqSp.matches;

            secs.forEach((sec) => {
                const btn = sec.querySelector('.js-accTtlBtn');
                const cnt = sec.querySelector('.js-accCnt');
                if (!btn || !cnt) return;

                // PC：常時開き（アコーディオン無効）
                if (spOnly && !isSp) {
                    sec.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                    cnt.style.display = 'block';
                    return;
                }

                // SP：is-open に合わせて表示
                const opened = sec.classList.contains('is-open');
                btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
                cnt.style.display = opened ? 'block' : 'none';
            });
        };

        const toggle = (btn) => {
            // PC時は無効
            if (spOnly && !mqSp.matches) return;

            const sec = btn.closest('.js-accSec');
            const cnt = sec?.querySelector('.js-accCnt');
            if (!sec || !cnt) return;

            const willOpen = !sec.classList.contains('is-open');
            sec.classList.toggle('is-open', willOpen);
            btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            cnt.style.display = willOpen ? 'block' : 'none';
        };

        // クリック（イベント委譲）
        menu.addEventListener('click', (e) => {
            const btn = e.target.closest('.js-accTtlBtn');
            if (!btn) return;
            toggle(btn);
        });

        // Enter / Space
        menu.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            const btn = e.target.closest('.js-accTtlBtn');
            if (!btn) return;
            e.preventDefault();
            toggle(btn);
        });

        // 初期適用 & ブレイクポイント切り替え追従
        applyMode();
        mqSp.addEventListener('change', applyMode);
    });
})();